<template>
  <UIModal v-model="isModalOpen" :close-button="!isLoading" :close-on-click-outside="!isLoading">
    <template #header>
      <div class="tw:flex tw:flex-col tw:items-center tw:gap-5">
        <h3 class="tw:font-bold tw:text-white tw:text-3xl tw:text-center">{{ $t('realtyCancelRentTitle') }}</h3>
        <p class="tw:text-xl tw:text-center">{{ $t('realtyCancelRentDescription') }}</p>
      </div>
    </template>
    <template #default>
      <div class="flex flex-col gap-1 tw:py-4">
        <p class="tw:text-xl tw:text-center m-0">{{ $t('realtyCancelRentSelectedHouses') }}:</p>
        <div
          class="tw:flex tw:flex-wrap tw:justify-center tw:items-center tw:gap-2 tw:mx-auto tw:p-2 tw:sm:min-w-xl tw:max-w-96"
        >
          <p
            v-for="house in $props.selectedHouses.slice(0, 20)"
            :key="house.address + house.buildingType + house.tokenId"
            class="tw:text-xl tw:text-center"
          >
            {{ $t(house.nameKey)
            }}{{ $props.selectedHouses.indexOf(house) !== $props.selectedHouses.length - 1 ? ',' : '' }}
          </p>
        </div>
      </div>
      <div class="tw:flex tw:flex-col tw:mx-auto tw:px-5 tw:py-6 tw:sm:min-w-xl">
        <p class="tw:text-xl tw:text-center">{{ $t('realtyCancelRentConfirmation') }}</p>
      </div>
    </template>
    <template #footer>
      <div class="tw:flex tw:justify-center tw:gap-2">
        <HalloweenGenericButton :disabled="isLoading" @click="handleConfirm">{{
          $t('realtyCancelRentYes')
        }}</HalloweenGenericButton>
        <HalloweenGenericButton :disabled="isLoading" @click="handleCancel">{{
          $t('realtyCancelRentNo')
        }}</HalloweenGenericButton>
      </div>
    </template>
  </UIModal>
</template>

<script lang="ts" setup>
import { useRentEventStore } from '~/stores/rent-event-store';
import type { IUserHouseInterface } from '~/stores/rent-event-store';

const { selectedHouses } = defineProps<{
  selectedHouses: IUserHouseInterface[];
}>();

const isModalOpen = defineModel<boolean>({ required: true });

const { unstakeHouses } = useRentEventStore();

const handleCancel = () => (isModalOpen.value = false);

const isLoading = ref(false);
async function handleConfirm() {
  if (selectedHouses.length === 0) return;
  try {
    isLoading.value = true;
    await unstakeHouses(selectedHouses);
  } catch {
    // TODO: handle error
  } finally {
    isLoading.value = false;
    isModalOpen.value = false;
  }
}
</script>
